import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/dashboard/account/')({
    component: RouteComponent,
    beforeLoad: () => {
        throw redirect({ to: '/dashboard' });
    },
});

function RouteComponent() {
    return (
        <>
        </>
    );
}
